import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from '../../_services';
import {first} from 'rxjs/operators';
import {passwordMatchValidator} from '../../_validators/validators';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-update-password',
  templateUrl: './update-password.component.html',
  styleUrls: ['./update-password.component.css']
})
export class UpdatePasswordComponent implements OnInit {
  resetForm: FormGroup;
  returnUrl: string;
  submitted: boolean;
  loading: boolean;
  error: '';
  deviceInfo = null;
  public passwordResetResponse: Object;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
  ) {
    this.resetForm = this.formBuilder.group({
      oldPassword: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(8)]],
      newPasswordConfirmation: ['', [Validators.required, passwordMatchValidator]]
    });

    this.r.password.valueChanges
      .subscribe(c => this.r.newPasswordConfirmation.updateValueAndValidity());
  }

  ngOnInit(): void {
  }

  get r() {
    return this.resetForm.controls;
  }

  updatePassword() {
    this.submitted = true;

    if (this.resetForm.invalid) {
      return;
    }

    this.loading = true;

    this.authenticationService.updatePassword(this.r.oldPassword.value, this.r.password.value)
      .subscribe(resp => {
        Swal.fire(
          'Updated!',
          'Password successfully changed.',
          'success'
        );
      }, error => {
        Swal.fire(
          'Failed!',
          'Failed to update password',
          'error'
        );
      }, () => {
        localStorage.removeItem('loggedInClient');
        this.router.navigate(['/login']).then(r => {
          window.location.reload();
        });
      });
  }
}
